import { createSlice } from "@reduxjs/toolkit";

// Images are served under "/api/watermark" in the backend, but the API returns
// paths starting with "/static/". Prefix those so they resolve correctly.
const resolveImageUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("/static/")) return `/api/watermark${url}`;
  return url;
};

const watermarkDecoderSlice = createSlice({
  name: "watermarkDecoder",
  initialState: {
    uploadLoading: false,
    results: null,
    manualLoading: false,
    manualResult: null,
  },
  reducers: {
    RequestWatermarkUpload: (state) => {
      state.uploadLoading = true;
    },
    SuccessWatermarkUpload: (state, action) => {
      const data = action.payload || {};
      state.uploadLoading = false;
      state.results = {
        originalImage: resolveImageUrl(data.original_image) || null,
        deblurImage: resolveImageUrl(data.deblur_image) || null,
        enhancedImages: (data.enhanced_images || []).map((img) => ({
          ...img,
          url: resolveImageUrl(img.url),
        })),
        watermarks: data.watermarks || [],
        status: data.status || null,
      };
    },
    FailureWatermarkUpload: (state) => {
      state.uploadLoading = false;
    },
    RequestManualWatermarkDecode: (state) => {
      state.manualLoading = true;
    },
    SuccessManualWatermarkDecode: (state, action) => {
      state.manualLoading = false;
      state.manualResult = action.payload || null;
    },
    FailureManualWatermarkDecode: (state) => {
      state.manualLoading = false;
    },
    ResetWatermarkDecoder: (state) => {
      state.uploadLoading = false;
      state.results = null;
      state.manualLoading = false;
      state.manualResult = null;
    },
  },
});

export default watermarkDecoderSlice;
